import { Module } from 'vuex';

import { RootState } from 'frontend/types';

interface ProfitwellState {
  token: string;
}

const profitwellApiToken: Module<ProfitwellState, RootState> = {
  namespaced: true,
  state: {
    token: '',
  },
  mutations: {
    setValue(state: ProfitwellState, value: string) {
      state.token = value;
    },
  },
};

export default profitwellApiToken;
